module.exports = __webpack_public_path__ + "img/user-for-openbadge-2.5bb54726.png";